<div class="dialog-container">
  <h2 mat-dialog-title>Update Project</h2>
  
  <mat-dialog-content>
    <div class="project-info">
      <span class="project-value">{{ projectId }}</span>
    </div>
    
    <div class="form-fields">
      <mat-form-field class="full-width">
        <mat-label>Change Area</mat-label>
        <mat-select [formControl]="changeAreaControl" required>
          <mat-option *ngFor="let option of changeAreaOptions" [value]="option.value">
            {{ option.label }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="changeAreaControl.hasError('required')">Change Area is required</mat-error>
      </mat-form-field>
      
      <mat-form-field class="full-width">
        <mat-label>Update Revision</mat-label>
        <input matInput [formControl]="updateRevisionControl" readonly>
      </mat-form-field>
      
      <mat-form-field *ngIf="showInServiceDate" class="full-width">
        <mat-label>In Service Date</mat-label>
        <input matInput [matDatepicker]="inServiceDatePicker" [formControl]="inServiceDateControl" required>
        <mat-datepicker-toggle matSuffix [for]="inServiceDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #inServiceDatePicker></mat-datepicker>
        <mat-error *ngIf="inServiceDateControl.hasError('required')">In Service Date is required</mat-error>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="confirmUpdate()">Save</button>
    <button mat-button (click)="closeDialog()">Cancel</button>
  </mat-dialog-actions>
</div>
